// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};
var bfs_SearchInputs = [];

function closeDisplayVariantInSearchMobile(elem) {
  jQuery(elem).parent().css("display", "none");
  return false;
}

function maybeDisplayVariantsInSearch(self, e) {
  let baseProductUrl = jQuery(self).data('baseUrl').url;
  let $variantListElem = jQuery(self).find('div.goe-variant-list');
  if($variantListElem.length === 0) {
    let variants = jQuery(self).data('variants');
    let variantHtmlArray = [];
    for(var i = 0; i < variants.length; i++) {
      let variantUrl = `${baseProductUrl}?variant=${variants[i].id}`;
      let optColor = ``;
      if(variants[i].color.length > 0) {
        optColor = ` (${variants[i].color})`;
      }
      variantHtmlArray.push(`<div class="goe-variant-item">
        <a class="tooltip" title="${variants[i].sku}" href="${variantUrl}">
          <span class="goe-variant-title tooltiptext tooltiptext-top">${variants[i].sku}${optColor}</span>
          <img width="32px" class="goe-variant-img" src="${variants[i].img}">
        </a>
      </div>`);
    }
    jQuery(self).prepend(`<div style="display:none;" class="goe-variant-list"><a href="javascript:void(0)" onclick="closeDisplayVariantInSearchMobile(this)" class="goe-variant-list-close">Close (x)</a>${variantHtmlArray.join('')}</div>`);
    $variantListElem = jQuery(self).find('div.goe-variant-list');
  }
  if(typeof e === 'PointerEvent') console.log(e);

  if(e.type === 'mouseover' || e.type === 'click') {
    $variantListElem[0].style.display = "flex";
    return;
  }
  if(e.type === 'mouseout') {
    $variantListElem[0].style.display = "none";
    return;
  }
}

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
      var suggestionElement = this.$uiMenuElement;
      var searchElement = this.$element;
      var searchBoxId = this.id;
  };
  
  SearchInput.prototype.afterInit = function() {
      bfs_SearchInputs.push(this);
  };

  InstantSearch.prototype.afterRender = function() {
    document.querySelectorAll('.boost-pfs-filter-product-item').forEach((elem, index) => {
      const $productItemElem = jQuery(elem);
      maybeDisplayVariantsInSearchList(elem);
      if(jQuery(elem).hasClass('exact-match')) {
        const self = this;
        jQuery(elem).find('.boost-pfs-addtocart-select-options').on('click', function(e) {
          const exactMatch = $productItemElem.data('exactMatch');
          let optionSelectClass = '.boost-pfs-swatch-element.' + slugify(exactMatch.title) + ' input';
          setTimeout(function(){
            let $quickViewSelectOption = $productItemElem.find(optionSelectClass);
            $quickViewSelectOption.trigger('click');
          }, 400);
        });
      }
    });
  };

  var instantSearchItemProductAfterRender = InstantSearchResultItemProduct.prototype.afterRender;
  InstantSearchResultItemProduct.prototype.afterRender = function() {
    if(this.data) {
      if(this.data.variants.length > 0 && this.data.product_type === "HARDWARE") {
        const activeSearchInput = bfs_SearchInputs.filter((input, index, arr) => {
          return input.$element.val();
        });
        if (!activeSearchInput[0]) {
            return;
        }
        this.$element.data('baseUrl', {url: this.url});
        this.$element.addClass("goe-boost-multiple-variants").css("position", "relative");
        const searchTerm = activeSearchInput[0].$element.val().toLowerCase();
        const returnItemVariants = this.data.variants.filter(variant => variant.sku.toLowerCase().includes(searchTerm));
        if(returnItemVariants.length == 0) return;

        const defaultThumbnail = this.data.imageUrl ?? this.$element.find('.boost-pfs-search-suggestion-left > img').attr('src');

        const itemVariantSkus = returnItemVariants.map(variant => {
          let colorOptions = variant.merged_options.map(opt => {
            let color = '';
            if(opt.includes("color:")) {
              return opt.replace("color:","");
            }
            if(opt.includes("material_type:")) {
              return opt.replace("material_type:","");
            }
            if(opt.includes("sku:")) {
              let matches = opt.match(/\(([^)]+)\)/);
              return matches[1] ?? opt.replace("sku:","");
            }
            return color;
          });
          return { sku: variant.sku, id: variant.id, color: colorOptions.filter(c => c), img: variant.image ?? defaultThumbnail };
        });
        if(returnItemVariants.length > 1) { // tell the customer that there are multiple matching skus under this result.
          this.$element.find('.boost-pfs-search-suggestion-product-sku').text("SKU: " + this.sku + " +" + (returnItemVariants.length - 1) + " more skus");
        }
        let possibleExactSearchMatch = itemVariantSkus.filter(doesSearchMatch => doesSearchMatch.sku.toLowerCase().includes(searchTerm));
        if(returnItemVariants.length == 1 && possibleExactSearchMatch.length == 1) {
          this.$element.find('.boost-pfs-search-suggestion-left > img').attr('src', itemVariantSkus[0].img);
          this.$element.find('a').attr('href', this.url + '?variant=' + itemVariantSkus[0].id);
          this.$element.find('.boost-pfs-search-suggestion-product-sku').text("SKU: " + itemVariantSkus[0].sku);
        }
        else if(returnItemVariants.length > 1) {
          this.$element.data('variants', itemVariantSkus);
          this.$element.off('hover').hover(function(e) {
              maybeDisplayVariantsInSearch(this, e);
          });
          if(Station.GrandCentral.Utilities.screenSize() === 'small') {
            this.$element.off('click').on('click', function(e) {
                e.preventDefault();
                if(e.target.className === 'goe-variant-list-close') return;
                maybeDisplayVariantsInSearch(this, e);
            });
          }
        }
        return;
      }
    }
    instantSearchItemProductAfterRender.call(this);
  }
  
  var instantSearchItemProductCompile = InstantSearchResultItemProduct.prototype.compileTemplate;
  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
    return instantSearchItemProductCompile.call(this);
  }
  
  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button';
    var searchInputMobile = '.search-input-group input[type="search"]';
    var searchCloseButtonMobile = '.drawer__close > button';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

})();